import * as z from 'zod';

// Types
import { GradientZod } from '@/types/GradientType';
import { MediaZod } from '@/types/MediaType';
import { TitleZod } from '@/types/TitleType';
import { CTAZod } from '@/types/CTAType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';
import { WaveShapeEnum } from '@/enum/WaveShapeEnum';

const HeroSectionZod = z.object({
  __component: z.literal('block.hero-section'),
  id: z.number(),
  title: TitleZod,
  paragraph: ParagraphZod,
  cta: CTAZod.nullable(),
  shape: z.enum([WaveShapeEnum.CONVEX, WaveShapeEnum.CONCAVE, WaveShapeEnum.WAVY]),
  color: z
    .enum([
      ColorThemeEnum.DARKBLUE,
      ColorThemeEnum.DARKBLUE_REVERT,
      ColorThemeEnum.BLUE,
      ColorThemeEnum.BLUE_REVERT,
      ColorThemeEnum.PURPLE,
      ColorThemeEnum.PURPLE_REVERT,
      ColorThemeEnum.ORANGE,
      ColorThemeEnum.ORANGE_REVERT,
      ColorThemeEnum.GREEN,
      ColorThemeEnum.GREEN_REVERT,
      ColorThemeEnum.WHITE,
    ])
    .nullable(),
  gradient: GradientZod.nullable(),
  scale: z.enum(['regular', 'large']),
  sideCTA: CTAZod.nullable(),
  media: MediaZod.nullable(),
});

export { HeroSectionZod };
export type HeroSectionType = z.infer<typeof HeroSectionZod>;
